import { render, staticRenderFns } from "./EditProductCategory.vue?vue&type=template&id=0d12b70e&scoped=true"
import script from "./EditProductCategory.vue?vue&type=script&lang=js"
export * from "./EditProductCategory.vue?vue&type=script&lang=js"
import style0 from "./EditProductCategory.vue?vue&type=style&index=0&id=0d12b70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12b70e",
  null
  
)

export default component.exports